export function buildAssetUrl({ content, mimeType, url, }) {
    return url ?? (content ? `data:${mimeType};base64,${content}` : '');
}
/**
 * Decode a base64 string into its original bytes.
 */
export function decodeBase64Bytes(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
/**
 * Decode a base64 string as UTF-8 text. Unlike bare `atob()`, this correctly
 * handles multi-byte UTF-8 characters (e.g. em dashes, CJK, emoji).
 */
export function decodeBase64Utf8(base64) {
    return new TextDecoder().decode(decodeBase64Bytes(base64));
}
//# sourceMappingURL=assetContentUtils.js.map